import sanityClient from "@sanity/client";

export const id = (window as any).marketplaceConfig?.project_id || "91x866mv";

export default sanityClient({
  projectId: id,
  dataset: "production",
});
